// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-detail-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 700px;
}

  .department-detail-sidebar__header-right-text {
        color: #8e8e93;
      }

  .department-detail-sidebar__navigation-button {
      width: 150px;
      height: 58px;
      align-items: center;
      padding: 15px 20px 15px 0;
    }

  .department-detail-sidebar__navigation-button svg {
        height: 19px;
        margin-left: 0;
      }

  .department-detail-sidebar__navigation-button > .sidebar-nav-link__icon-wrap{
        min-width: var(--right-sidebar-navigation-closed-width);
      }

  .department-detail-sidebar__navigation-button > .sidebar-nav-link__value{
        margin-left: 0;
      }

  .department-detail-sidebar__navigation-button:hover {
        background-color: #e8fcf1;
      }

  .department-detail-sidebar__navigation-button-selected {
        background-color: white;
      }

  .department-detail-sidebar__navigation-button-selected svg {
          fill: #24b148;
        }

  .department-detail-sidebar__navigation-button-count {
        font-size: 12px;
        color: white;
        height: 16px;
        background-color: #24b148;
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding: 0 5px;
      }

  .department-detail-sidebar__navigation-button-spinner {
        width: 15px;
        height: 15px;
      }

  .department-detail-sidebar__navigation-button-spinner-container {
          position: absolute;
          left: 30px;
          top: 12px;
        }

  .department-detail-sidebar__content {
    display: flex;
    overflow-y: scroll;
    flex-grow: 1;
    padding: 30px;
    padding-right: calc(var(--right-sidebar-navigation-closed-width) + 15px);
  }

  .department-detail-sidebar__form {
    padding: 0 12px;
  }

  .department-detail-sidebar__group-title {
      font-weight: 500;
      width: 100%;
      line-height: 24px;
      font-size: 14px;
      margin-top: 25px;
    }

  .department-detail-sidebar__label {
    opacity: 0.5;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
  }

  .department-detail-sidebar__multi-input-row {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }

  .department-detail-sidebar__input-field-container {
    flex-grow: 1;
  }

  .department-detail-sidebar__input-field {
    margin-bottom: 10px;
    width: 100%;
    border-radius: 0;
  }

  .department-detail-sidebar__input-field-small {
      max-width: 65px;
      flex-grow: 0;
      margin-left: 6px;
    }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAoHlB;;EAhHM;QACE,cAAc;MAChB;;EAKF;MACE,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB,yBAAyB;IAgD3B;;EA9CE;QACE,YAAY;QACZ,cAAc;MAChB;;EAEA;QACE,uDAAuD;MACzD;;EAEA;QACE,cAAc;MAChB;;EAEA;QACE,yBAAyB;MAC3B;;EAEA;QACE,uBAAuB;MAKzB;;EAHE;UACE,aAAa;QACf;;EAGF;QACE,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,cAAc;MAChB;;EAEA;QACE,WAAW;QACX,YAAY;MAOd;;EALE;UACE,kBAAkB;UAClB,UAAU;UACV,SAAS;QACX;;EAKN;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,wEAAwE;EAC1E;;EAEA;IACE,eAAe;EACjB;;EAGE;MACE,gBAAgB;MAChB,WAAW;MACX,iBAAiB;MACjB,eAAe;MACf,gBAAgB;IAClB;;EAGF;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAOlB;;EALE;MACE,eAAe;MACf,YAAY;MACZ,gBAAgB;IAClB","sourcesContent":[".department-detail-sidebar {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 700px;\n\n  &__header {\n    &-right {\n      &-text {\n        color: #8e8e93;\n      }\n    }\n  }\n\n  &__navigation {\n    &-button {\n      width: 150px;\n      height: 58px;\n      align-items: center;\n      padding: 15px 20px 15px 0;\n\n      & svg {\n        height: 19px;\n        margin-left: 0;\n      }\n\n      & > .sidebar-nav-link__icon-wrap{\n        min-width: var(--right-sidebar-navigation-closed-width);\n      }\n\n      & > .sidebar-nav-link__value{\n        margin-left: 0;\n      }\n\n      &:hover {\n        background-color: #e8fcf1;\n      }\n\n      &-selected {\n        background-color: white;\n\n        & svg {\n          fill: #24b148;\n        }\n      }\n\n      &-count {\n        font-size: 12px;\n        color: white;\n        height: 16px;\n        background-color: #24b148;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        padding: 0 5px;\n      }\n\n      &-spinner {\n        width: 15px;\n        height: 15px;\n\n        &-container {\n          position: absolute;\n          left: 30px;\n          top: 12px;\n        }\n      }\n    }\n  }\n\n  &__content {\n    display: flex;\n    overflow-y: scroll;\n    flex-grow: 1;\n    padding: 30px;\n    padding-right: calc(var(--right-sidebar-navigation-closed-width) + 15px);\n  }\n\n  &__form {\n    padding: 0 12px;\n  }\n\n  &__group {\n    &-title {\n      font-weight: 500;\n      width: 100%;\n      line-height: 24px;\n      font-size: 14px;\n      margin-top: 25px;\n    }\n  }\n\n  &__label {\n    opacity: 0.5;\n    font-size: 12px;\n    line-height: 24px;\n    font-weight: 500;\n  }\n\n  &__multi-input-row {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n  }\n\n  &__input-field-container {\n    flex-grow: 1;\n  }\n\n  &__input-field {\n    margin-bottom: 10px;\n    width: 100%;\n    border-radius: 0;\n\n    &-small {\n      max-width: 65px;\n      flex-grow: 0;\n      margin-left: 6px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
